import React, { useEffect } from 'react';
import LoadingScreen from './components/LoadingScreen';
import NotistackProvider from './components/NotistackProvider';
import ScrollToTop from './components/ScrollToTop';
import ThemeLocalization from './components/ThemeLocalization';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import useAuth from './hooks/useAuth';
import { useSelector } from './redux/store';
import Router from './routes';
import ThemeConfig from './theme';
import { useDispatch } from 'react-redux';
import { Toaster } from "src/@/components/ui/toaster"
import NotificationGate from './components/NotificationGate';
import { clarity } from 'react-microsoft-clarity';
import { getGlobalConfig } from './redux/slices/global';
import { verificarUrlProvider } from './utils/functions';
import config from './config';
import * as Sentry from '@sentry/react';

export default function App() {
  const { isInitialized, cliente, logout } = useAuth();
  const { defcon } = useSelector((state) => state.global);
  const dispatch = useDispatch();


  const verificaTimeToken = () => {
    const userLocal = localStorage.getItem('user');
    if (!userLocal || userLocal === "undefined" || userLocal === "null") {
      logout();
      return;
    }
    const user = JSON.parse(localStorage.getItem('user')); // Supondo que o usuário esteja armazenado no localStorage
    if (!user || !user?.exp || user === "undefined") {
      logout()
      return;
    }
  }

  useEffect(() => {
    console.log('useEffect App mount');
    verificaTimeToken();
    const url = verificarUrlProvider();
    dispatch(getGlobalConfig(url));
  }, [defcon]);

  Sentry.init({
    dsn: "https://ab34ebfcf9f9adc394b7a9ae8aa01b67@o4508955890221056.ingest.us.sentry.io/4508957525213184"
  });


  if (!config.dev) {
    clarity.init("njqf38l8k6");
  }


  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <ThemeLocalization>
          <NotistackProvider>
            <ScrollToTop />
            <Toaster duration={4000} />
            <NotificationGate />
            {isInitialized ? <Router /> : <LoadingScreen />}
          </NotistackProvider>
        </ThemeLocalization>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
